<template>
    <button class="btn btn-primary has-spinner">
        <span v-show="! loading">
            <slot></slot>
        </span>
        <span v-show="loading" class="spinner"></span>
    </button>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
        },
    },
}
</script>
